export const loadCustomizerState = () => {
  try {
    const serialized = localStorage.getItem('customizer');
    if (!serialized) return undefined;

    return { customizer: JSON.parse(serialized) };
  } catch (e) {
    console.warn('Failed to load state', e);
    return undefined;
  }
};

export const saveCustomizerState = (state: any) => {
  try {
    localStorage.setItem('customizer', JSON.stringify(state));
  } catch (e) {
    console.warn('Failed to save customizer state', e);
  }
};
